<script>
  import Page from '@components/page'
  import Button from '@components/buttons/button.svelte'
  import { page } from '@inertiajs/svelte'
  import { Hand, ArrowRight } from 'lucide-svelte'

  let user = $page.props.user
  let subtitle = `Great to have you here, ${user.name}!`

</script>

<Page.Layout title="Welcome to Altruist Wellbeing">
  
  <Page.Navigation title="Welcome" Icon={Hand} />
  
  <Page.Titles title="Altruist Wellbeing Platform" subtitle="Welcome to our platform!" />
  
  <Page.Content>

    {#snippet main()}
      <div>
        <p class="prose">Welcome to the Altruist Wellbeing platform. Here you can find a range of resources to help you look after your mental health and wellbeing.</p>

        {#if !user.has_active_membership}
          <p class="prose">You don't have a membership yet, so access to our resources is limited.</p>
          <Button text="Create membership" path="/register" class="primary mt-6" Icon={ArrowRight} />
        {/if}
      </div>
    {/snippet}

    {#snippet aside()}
      <p>Some links here...</p>
    {/snippet}
    
  </Page.Content>
  
</Page.Layout>